import React from "react";
import SectionTitle from "../../components/shared/SectionTitle";

export default function () {
  return (
    <div>
      <div className=" py-32 bg-text relative w-full">
        <SectionTitle
          title="TECHNICAL CAPABILITIES"
          description="With 200+ projects and approximately 43 millions active app users, we understand the utmost importance of technologies in delivering the most effective and innovative products"
          classDescription="w-full text-lg lg:text-center"
        ></SectionTitle>
      </div>
    </div>
  );
}
